namespace TabAurous.OMS {
    export interface ProductMoldsForm {
        ProductId: Serenity.IntegerEditor;
        MoldId: Serenity.IntegerEditor;
        Pcs: Serenity.IntegerEditor;
    }

    export class ProductMoldsForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ProductMolds';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductMoldsForm.init)  {
                ProductMoldsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(ProductMoldsForm, [
                    'ProductId', w0,
                    'MoldId', w0,
                    'Pcs', w0
                ]);
            }
        }
    }
}
